import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Seo from './Seo';
import { SITE_NAME, SITE_URL } from '../seo';

function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_LOGIN_PASSWORD) {
      localStorage.setItem('loggedIn', 'true');
      navigate('/');
    } else {
      setError('Invalid password');
    }
  };

  return (
    <div className="p-10 max-w-md mx-auto">
      <Seo
        title={`Login | ${SITE_NAME}`}
        description="Private administration login for MEZZANINE."
        canonicalUrl={`${SITE_URL}/login/`}
        robots="noindex, nofollow"
      />
      <h1 className="text-2xl mb-4">Login</h1>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="password"
          className="border p-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {error && <div className="text-red-500">{error}</div>}
        <button type="submit" className="bg-black text-white p-2">Login</button>
      </form>
    </div>
  );
}

export default Login;
